import { createAction, props } from '@ngrx/store';
import { CourseState } from './course.state';

export const UpdateStateReducer = createAction('[Course] UpdateStateReducer', props<{ value: CourseState }>());
export const SelectTypeReducer = createAction('[Course] SelectTypeReducer', props<{ type_active: any }>());
